import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import "./switch.scss";

function SwitchAtom(props) {
	const { label, type, checked, onChange, error = "" } = props;
	const { t } = useTranslation();

	return (
		<div className="switch-wrapper">
			<Form.Check
				type={type}
				id="custom-switch"
				label={label}
				checked={checked}
				onChange={onChange}
			/>
			{error && <p className="switch-error">{t(error)}</p>}
		</div>
	);
}

export default SwitchAtom;
